export enum HelpContentTypeEnum {
    Html = 0,
    Video = 1,
    Markdown = 2
}
